export default "__VITE_ASSET__6e932901__"